const playButton = document.querySelector(".homepage-banner__play");
const imagePlaceholder = document.querySelector(".homepage-banner__bg img");
const iframe = document.querySelector(".homepage-banner__bg iframe");
const container = document.querySelector(".homepage-banner__bg");
const banner = document.querySelector(".homepage-banner");

const handleChange = () => {
  const url = imagePlaceholder.dataset.iframe;
  iframe.setAttribute("src", url);
  banner.classList.add("active");
};

const changePlaceholderToVideo = () => {
  if (playButton) {
    playButton.addEventListener("click", () => {
      handleChange();
    });

    playButton.addEventListener("keyup", function(e) {
      if (e.keyCode === 13) {
        handleChange();
      }
    });
  }
};

changePlaceholderToVideo();
